// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-order-logo[data-v-64ef2d48],.table-order-logo_avatar[data-v-64ef2d48]{-o-object-fit:cover;object-fit:cover}.table-order-logo_avatar[data-v-64ef2d48]{border-radius:50%;font-size:13px;font-weight:700;display:flex;align-items:center;justify-content:center;text-transform:uppercase;color:var(--v-primary-600-base);background-color:var(--v-primary-50-base)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
